import { render, staticRenderFns } from "./BaseBox.vue?vue&type=template&id=77d3b39e&scoped=true&"
import script from "./BaseBox.vue?vue&type=script&lang=js&"
export * from "./BaseBox.vue?vue&type=script&lang=js&"
import style0 from "./BaseBox.vue?vue&type=style&index=0&id=77d3b39e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d3b39e",
  null
  
)

export default component.exports